import React, { useRef } from "react";
import AppContainer from "../../../components/AppContainer";
import { Chip, Grid, MenuItem, Stack, Typography, Box } from "@mui/material";
import ImageUploader from "../../../components/ImageUploader";
import { appLogo } from "../../../assets";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import globalStyle from "../../../globalStyle";
import { DatePicker } from "@mui/x-date-pickers";
import CustomDropDown from "../../../components/CutomDropDown";
import CusomCheckBox from "../../../components/CustomCheckbox";
import GlobalButton from "../../../components/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";

const allClasses = [
  "1st class",
  "2nd class",
  "3rd class",
  "4th class",
  "5th class",
  "6th class",
  "7th class",
  "8th class",
  "9th class",
  "10th classs",
];

const allGrades = ["A+1", "A", "B", "C", "D", "E"];
const feeType = ["Installment 1", "Installment 2", "Installment 3"];

const AdmissionReqDetails = () => {
  const dispatch = useDispatch();
  const uploadTranscriptRef = useRef(null);

  const activeTab = useSelector((state) => state.activeTab.tabs);

  const handleBack = () => {
    dispatch(
      setActiveTab({
        ...activeTab,
        education_admission: "ed_admission_request",
      })
    );
  };

  return (
    <AppContainer
      primaryHeading={"Admission Request Form"}
      secondaryHeading={"All Details"}
      showBackButton={true}
      handleBack={handleBack}
    >
      <Stack textAlign={"center"}>
        <Typography variant="h4" fontWeight={600}>
          Admission Form
        </Typography>
        <Typography variant="body1">
          For the purpose of industry regulation, Your details are required
        </Typography>
      </Stack>

      <Stack
        my={2}
        direction={"row"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <ImageUploader avatarSize={150} image={appLogo.schoologo} />
      </Stack>

      <Typography mb={1} variant="h6" fontWeight={500}>
        Personal Information
      </Typography>

      <Grid container my={2} spacing={2}>
        <Grid item xs={12} sm={3}>
          <Label labelText="First name" required htmlFor={"std_first_name"} />
          <TextInput
            id={"std_first_name"}
            required
            styleProps={globalStyle.textField}
            placeholder={"Enter first name"}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Label labelText="Last name" required htmlFor={"std_last_name"} />
          <TextInput
            id={"std_last_name"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter last name"}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Label labelText="Birthday" required htmlFor={"std_birth_date"} />
          <DatePicker
            sx={{
              "&.MuiTextField-root": { width: "100% !important" },
              ...globalStyle.textField,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Label labelText="Gender" required htmlFor={"std_gender"} />

          <CustomDropDown>
            <MenuItem>Male</MenuItem>
            <MenuItem>Female</MenuItem>
            <MenuItem>Other</MenuItem>
          </CustomDropDown>
        </Grid>
        <Grid item xs={12}>
          <Label
            labelText="First Address"
            required
            htmlFor={"std_first_address"}
          />
          <TextInput
            id={"std_first_address"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter first address"}
          />
        </Grid>
        <Grid item xs={12}>
          <Label
            labelText="2nd Address"
            required
            htmlFor={"std_second_address"}
          />
          <TextInput
            id={"std_second_address"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter first address"}
          />
        </Grid>
      </Grid>

      <Typography mb={1} variant="h6" fontWeight={500}>
        Contact Information
      </Typography>

      <Grid container my={1.5} spacing={2}>
        <Grid item xs={12} sm={4}>
          <Label
            labelText="Mobile number"
            required
            htmlFor={"std_mobile_number"}
          />
          <TextInput
            id={"std_mobile_number"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter mobile number"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label labelText="Home number" required htmlFor={"std_home_number"} />
          <TextInput
            id={"std_home_number"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter home number"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label
            labelText="Emial Address"
            required
            htmlFor={"std_email_number"}
          />
          <TextInput
            id={"std_email_number"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter Email address"}
          />
        </Grid>
      </Grid>

      <Typography mb={1} variant="h6" fontWeight={500}>
        Parent/Guardian Information
      </Typography>

      <Grid container my={1.5} spacing={2}>
        <Grid item xs={12} sm={4}>
          <Label labelText="First name" required htmlFor={"gr_first_name"} />
          <TextInput
            id={"gr_first_name"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter first name"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label labelText="Last name" required htmlFor={"gr_last_name"} />
          <TextInput
            id={"gr_last_name"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter last name"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label
            labelText="Relation ship"
            required
            htmlFor={"gr_relation_ship"}
          />
          <CustomDropDown>
            <MenuItem value={"Mother"}>Mother</MenuItem>
            <MenuItem value={"Father"}>Father</MenuItem>
          </CustomDropDown>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label
            labelText="Mobile number"
            required
            htmlFor={"gr_mobile_number"}
          />
          <TextInput
            id={"gr_mobile_number"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter mobile number"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label labelText="CNIC/Other" required htmlFor={"gr_cnic_number"} />
          <TextInput
            id={"gr_cnic_number"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter cnic number"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label
            labelText="Email Address"
            required
            htmlFor={"gr_emailaddress"}
          />
          <TextInput
            id={"gr_emailaddress"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter email address"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label
            labelText="Relation ship to parent"
            required
            htmlFor={"gr_relation_ship"}
          />
          <CustomDropDown>
            <MenuItem value={"Son"}>Son</MenuItem>
            <MenuItem value={"Daughter"}>Daughter</MenuItem>
          </CustomDropDown>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label
            labelText="Special education needed"
            required
            htmlFor={"gr_special_education"}
          />
          <CustomDropDown>
            <MenuItem value={"Yes"}>Yes</MenuItem>
            <MenuItem value={"Not"}>Not</MenuItem>
          </CustomDropDown>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label
            labelText="If yes than give us reason"
            required
            htmlFor={"gr_reason"}
          />
          <TextInput
            id={"gr_reason"}
            styleProps={globalStyle.textField}
            required
            placeholder={"E.g; He is weak in math"}
          />
        </Grid>
      </Grid>

      <Stack direction={"row"} alignItems={"center"} gap={1}>
        <CusomCheckBox isChecked={true} />
        <Typography variant="h6" fontWeight={500}>
          Health Information
        </Typography>
      </Stack>

      <Grid container my={1.5} spacing={2}>
        <Grid item xs={12} sm={4}>
          <Label labelText="Allergies" required htmlFor={"std_allergies"} />
          <CustomDropDown>
            <MenuItem value={"Yes"}>Yes</MenuItem>
            <MenuItem value={"No"}>No</MenuItem>
          </CustomDropDown>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Label
            labelText="Health condition"
            required
            htmlFor={"std_health_condition"}
          />
          <CustomDropDown>
            <MenuItem value={"Good"}>Good</MenuItem>
            <MenuItem value={"Normal"}>Normal</MenuItem>
            <MenuItem value={"Sick"}>Sick</MenuItem>
          </CustomDropDown>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Label labelText="Medication" required htmlFor={"std_medication"} />
          <CustomDropDown>
            <MenuItem value={"Yes"}>Yes</MenuItem>
            <MenuItem value={"No"}>No</MenuItem>
          </CustomDropDown>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Label
            labelText="Emergency contact number"
            required
            htmlFor={"std_emergency_contact_number"}
          />
          <TextInput
            id={"std_emergency_contact_number"}
            styleProps={globalStyle.textField}
            required
            placeholder={"Enter contact number"}
          />
        </Grid>
      </Grid>

      <Stack direction={"row"} alignItems={"center"} gap={1}>
        <CusomCheckBox isChecked={true} />
        <Typography variant="h6" fontWeight={500}>
          Previous School Details
        </Typography>
      </Stack>

      <Grid container my={1.5} spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Label
            labelText="Previous class"
            required
            htmlFor={"std_previous_class"}
          />
          <CustomDropDown>
            {allClasses.map((val, ind) => {
              return <MenuItem key={ind}>{val}</MenuItem>;
            })}
          </CustomDropDown>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label
            labelText="Previous school name"
            required
            htmlFor={"std_previous_school_name"}
          />
          <TextInput
            id={"std_previous_school_name"}
            required
            styleProps={globalStyle.textField}
            placeholder={"Enter previous school name"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label
            labelText="Last class grade"
            required
            htmlFor={"std_last_grade"}
          />
          <CustomDropDown>
            {allGrades.map((val, ind) => {
              return <MenuItem key={ind}>{val}</MenuItem>;
            })}
          </CustomDropDown>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label labelText="Attendance" required htmlFor={"std_attendance"} />
          <TextInput
            id={"std_attendance"}
            required
            styleProps={globalStyle.textField}
            placeholder={"Enter attendance"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label
            labelText="Student repeated class"
            required
            htmlFor={"std_repeated_class"}
          />
          <CustomDropDown>
            <MenuItem value={"Yes"}>Yes</MenuItem>
            <MenuItem value={"No"}>No</MenuItem>
          </CustomDropDown>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label
            labelText="Class Name"
            required
            htmlFor={"std_repeated_class_name"}
          />
          <CustomDropDown>
            {allClasses.map((val, ind) => {
              return <MenuItem key={ind}>{val}</MenuItem>;
            })}
          </CustomDropDown>
        </Grid>
        <Grid item xs={12}>
          <Label
            labelText="Reason leaving previous school"
            required
            htmlFor={"std_leave_reason"}
          />
          <TextInput
            id={"std_leave_reason"}
            required
            multiline
            rows={3}
            styleProps={globalStyle.textField}
            placeholder={"Enter attendance"}
          />
        </Grid>
      </Grid>

      <Typography variant="h6" fontWeight={500}>
        Current Admission
      </Typography>

      <Grid container my={1.5} spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Label labelText="Class" required htmlFor={"std_current_class"} />
          <CustomDropDown>
            {allClasses.map((val, ind) => {
              return <MenuItem key={ind}>{val}</MenuItem>;
            })}
          </CustomDropDown>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label labelText="Fee Type" required htmlFor={"std_fee_type"} />
          <CustomDropDown>
            {feeType.map((val, ind) => {
              return <MenuItem key={ind}>{val}</MenuItem>;
            })}
          </CustomDropDown>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label labelText="Admission Fee" required htmlFor={"std_fees"} />
          <TextInput
            id={"std_fees"}
            required
            styleProps={globalStyle.textField}
            placeholder={"E.g ; 800 USD"}
            InputEndIcon={
              <Typography variant="body1" color={"primary.main"}>
                Fixed
              </Typography>
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Label
            labelText="Tuition Fee"
            required
            htmlFor={"std_tuition_fees"}
          />
          <TextInput
            id={"std_tuition_fees"}
            required
            styleProps={globalStyle.textField}
            placeholder={"E.g ; 250 USD"}
            InputEndIcon={
              <Typography variant="body1" color={"primary.main"}>
                Fixed
              </Typography>
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Label labelText="Annual Fee" required htmlFor={"std_annual_fees"} />
          <TextInput
            id={"std_annual_fees"}
            required
            styleProps={globalStyle.textField}
            placeholder={"E.g ; 1000 USD"}
            InputEndIcon={
              <Typography variant="body1" color={"primary.main"}>
                Fixed
              </Typography>
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2.5}>
          <Label labelText="Discount%" required htmlFor={"std_discount"} />
          <TextInput
            id={"std_discount"}
            required
            styleProps={globalStyle.textField}
            placeholder={"Enter discount"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={1.5}>
          <Label labelText="Sub-Total" required htmlFor={"std_discount"} />
          <TextInput
            id={"std_discount"}
            required
            styleProps={globalStyle.textField}
            placeholder={"Enter discount"}
          />
        </Grid>
      </Grid>

      <Box>
        <Typography variant="h6" fontWeight={500} lineHeight={"normal"}>
          Documents Attachments
        </Typography>
        <Typography
          variant="body1"
          color={"custom.slateGrey"}
          lineHeight={"normal"}
        >
          Previuos school, college, Uni Records
        </Typography>
      </Box>

      <Grid container my={1.5} spacing={2} alignItems={"baseline"}>
        <Grid item xs={12} sm={3}>
          <GlobalButton
            startIcon={<AddIcon />}
            btnText={"Upload Transcripts"}
            handleClickBtn={() => uploadTranscriptRef.current.click()}
            styleProps={{
              height: 45,
            }}
          />
          <input
            ref={uploadTranscriptRef}
            type="file"
            style={{ display: "none" }}
          />
        </Grid>
        <Grid xs={12} sm={9}>
          <Stack ml={2} direction={"row"} alignItems={"center"} gap={1}>
            <Chip
              label="view file 1"
              color={"primary"}
              onDelete={() => console.log("deleted")}
            />
            <Chip
              label="view file 1"
              color={"primary"}
              onDelete={() => console.log("deleted")}
            />
          </Stack>
        </Grid>
      </Grid>

      <Grid container my={1.5} spacing={2} alignItems={"baseline"}>
        <Grid item xs={12} sm={3}>
          <GlobalButton
            btnText={"Upload Birth Certificate"}
            handleClickBtn={() => uploadTranscriptRef.current.click()}
            styleProps={{
              height: 45,
            }}
          />
          <input
            ref={uploadTranscriptRef}
            type="file"
            style={{ display: "none" }}
          />
        </Grid>
        <Grid item xs={12} md={9}>
          <Stack direction={"row"} alignItems={"center"} gap={1}>
            <Chip
              label="view file"
              color={"primary"}
              onDelete={() => console.log("deleted")}
            />
          </Stack>
        </Grid>
      </Grid>
      <Grid container my={1.5} spacing={2} alignItems={"baseline"}>
        <Grid item xs={12} sm={4}>
          <GlobalButton
            btnText={"Upload Guardian Identification"}
            handleClickBtn={() => uploadTranscriptRef.current.click()}
            styleProps={{
              height: 45,
            }}
          />
          <input
            ref={uploadTranscriptRef}
            type="file"
            style={{ display: "none" }}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <Stack direction={"row"} alignItems={"center"} gap={1}>
            <Chip
              label="view file 1"
              color={"primary"}
              onDelete={() => console.log("deleted")}
            />
          </Stack>
        </Grid>
      </Grid>
      <Grid container my={1.5} spacing={2} alignItems={"baseline"}>
        <Grid item xs={12} sm={3}>
          <GlobalButton
            btnText={"Upload Address Proof"}
            handleClickBtn={() => uploadTranscriptRef.current.click()}
            styleProps={{
              height: 45,
            }}
          />
          <input
            ref={uploadTranscriptRef}
            type="file"
            style={{ display: "none" }}
          />
        </Grid>
        <Grid item xs={12} md={9}>
          <Stack direction={"row"} alignItems={"center"} gap={1}>
            <Chip
              label="view file 1"
              color={"primary"}
              onDelete={() => console.log("deleted")}
            />
          </Stack>
        </Grid>
      </Grid>

      {/* Next to pay fee */}
      <Stack my={2} alignItems={"flex-end"}>
        <GlobalButton
          btnText={"Back to Request"}
          handleClickBtn={handleBack}
          styleProps={{
            height: 45,
            width: 150,
          }}
        />
      </Stack>
    </AppContainer>
  );
};

export default AdmissionReqDetails;
